import { Injectable } from '@angular/core';

declare var config: any;
declare var Keycloak: any;

@Injectable()
export class KeycloakService {
  static auth: any = { loggedIn: false };

  static init(): Promise<any> {
    if (config.devMode || KeycloakService.auth.loggedIn) {
      return new Promise((resolve, reject) => {
        resolve();
      });
    }

    let keycloakAuth: any = new Keycloak(config.webApiDomains.main.keycloakConfigUrl);
    KeycloakService.auth.loggedIn = false;

    return new Promise((resolve, reject) => {
      keycloakAuth.init({ onLoad: 'login-required' })
        .success(() => {
          let href = location.href;
          if (href.indexOf('#') > 0) {
            href = href.substring(0, href.indexOf('#'))
          }
          KeycloakService.auth.loggedIn = true;
          KeycloakService.auth.authz = keycloakAuth;
          KeycloakService.auth.logoutUrl = keycloakAuth.createLogoutUrl({redirectUri: href});
          resolve();
        })
        .error((bb) => {
          reject();
        });
    });
  }

  logout() {
    console.log('*** LOGOUT');
    KeycloakService.auth.loggedIn = false;
    KeycloakService.auth.authz = null;

    window.location.href = KeycloakService.auth.logoutUrl;
  }

  getToken(): Promise<string> {
    return new Promise<string>((resolve, reject) => {
      if (KeycloakService.auth.authz.token) {
        KeycloakService.auth.authz.updateToken(5)
          .success(() => {
            resolve(<string>KeycloakService.auth.authz.token);
          })
          .error(() => {
            reject('Failed to refresh token');
          });
      }
    });
  }
}


// WEBPACK FOOTER //
// C:/wxj/LicAuth/05開発/LicAuth.angularjs/src/app/keycloak.service.ts